module.exports = __webpack_public_path__ + "static/media/Physics.364a24af.svg";